import api from "./api";

// QR içindeki adres: panelin herkese açık adresi (mobil uygulamada https://localhost olmasın)
export const qrBase = () => (process.env.REACT_APP_BACKEND_URL || window.location.origin).replace(/\/+$/, "");

export async function getJobQrInfo(jobId) {
  const r = await api.get(`/qr/jobs/${jobId}`, { params: { base: qrBase() } });
  return r.data;
}

export async function getJobQrDataUrl(jobId) {
  const r = await api.get(`/qr/jobs/${jobId}/png`, { params: { base: qrBase() }, responseType: "blob" });
  return await new Promise((resolve, reject) => {
    const fr = new FileReader();
    fr.onload = () => resolve(fr.result);
    fr.onerror = reject;
    fr.readAsDataURL(r.data);
  });
}
